import { combineReducers } from '@reduxjs/toolkit';

import { appAPI } from 'src/services/api';
import { unAuthApi } from 'src/services/api/unauthApi';
import { usersApi } from 'src/services/api/usersApi';
import { activeCompanyReducer } from 'src/store/activeCompany/slice';
import aiAssistantStatusReducer from 'src/store/aiAssistantStatus/slice';
import { appBuilderPlaceholderReducer } from 'src/store/appBuilderPlaceholder/slice';
import { authReducer } from 'src/store/auth/slice';
import clients from 'src/store/clients/reducers';
import dashboard from 'src/store/dashboard/reducers';
import data from 'src/store/data/reducers';
import { draftReducer } from 'src/store/drafts/slice';
import extraDataReducer from 'src/store/entities/extraDataSlice';
import { entityImportReducer } from 'src/store/entityImporter/slice';
import files from 'src/store/files/reducers';
import knowledgeBase from 'src/store/knowledgeBase/reducers';
import messages from 'src/store/messages/reducers';
import notifications from 'src/store/notifications/reducers';
import optimisticUpdatesReducer from 'src/store/optimisticUpdates/slice';
import payments from 'src/store/payments/reducers';
import runtime from 'src/store/runtime/reducers';
import settings from 'src/store/settings/reducers';
import { shortcutsReducer } from 'src/store/shortcuts/slice';
import signaturePage from 'src/store/signaturePage/reducers';
import tableProperties from 'src/store/tableProperties/reducers';
import tags from 'src/store/tags/reducers';
import ui from 'src/store/ui/reducers';
import user from 'src/store/user/reducers';
import users from 'src/store/users/reducers';

export const rootReducer = combineReducers({
  clients,
  users,
  user,
  ui,
  runtime,
  data,
  settings,
  files,
  extraData: extraDataReducer,
  messages,
  payments,
  notifications,
  signaturePage,
  dashboard,
  shortcuts: shortcutsReducer,
  entityImports: entityImportReducer,
  tags,
  knowledgeBase,
  tableProperties,
  auth: authReducer,
  draft: draftReducer,
  activeCompany: activeCompanyReducer,
  aiAssistantStatus: aiAssistantStatusReducer,
  optimisticUpdates: optimisticUpdatesReducer,
  appBuilderPlaceholder: appBuilderPlaceholderReducer,
  [appAPI.reducerPath]: appAPI.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [unAuthApi.reducerPath]: unAuthApi.reducer,
});
